import { VulnerabilitiesOverview } from '@models';

export interface ProjectVulnerabilityOverviewResult {
  projectVulnerabilityOverview: VulnerabilitiesOverview;
}
